import { Component } from '@angular/core';
import { MdbModalRef, MdbModalService } from 'mdb-angular-ui-kit/modal';
import * as moment from 'moment';
import { firstValueFrom } from 'rxjs';
import { ModalSeeCodeRequestComponent } from 'src/app/components/crud/modal-see-code-request/modal-see-code-request.component';
import { environment } from 'src/app/environments/environments.dev';
import { GenericCrudService } from 'src/app/services/crud/generic-crud.service';

@Component({
  selector: 'app-list-code-request',
  templateUrl: './list-code-request.component.html',
  styleUrls: ['./list-code-request.component.css']
})
export class ListCodeRequestComponent {
  loadingFull: boolean = false;
  loading: any;
  currentPage: number = 1;
  itemsPerPage: number = 10;
  requestCodesPaginated: any[] = [];
  headers: any = [
    {
      label: '#',
      field: 'id',
      disableSort: false,
    },
    {
      label: 'Grupo contable',
      field: 'accounting_group',
      disableSort: false,
    },
    {
      label: 'Agrupación comercial',
      field: 'commercial_group',
      disableSort: false,
    },
    {
      label: 'Agrupación financiera',
      field: 'financial_group',
      disableSort: false,
    },
    { 
      label: 'Agrupación ejecutiva', 
      field: 'executive_group', 
      disableSort: false 
    },
    { 
      label: 'Artículo inventario', 
      field: 'inventory_item', 
      disableSort: false 
    },
    { 
      label: 'Artículo ventas', 
      field: 'inventory_sales', 
      disableSort: false 
    },
    { 
      label: 'Artículo compras', 
      field: 'inventory_shopping', 
      disableSort: false 
    },
    { 
      label: 'Método gestión', 
      field: 'management_method', 
      disableSort: false 
    },
    { 
      label: 'Origen', 
      field: 'origin', 
      disableSort: false 
    },
    { 
      label: 'Fecha creación', 
      field: 'created_at', 
      disableSort: false 
    },
    { 
      label: 'Estado', 
      field: 'status', 
      disableSort: false 
    },
    { 
      label: 'Acciones', 
      field: '', 
      disableSort: false 
    },
  ];

  requestCodes: any[] = [];
  modalRef: MdbModalRef<ModalSeeCodeRequestComponent> | null = null;

  constructor(
    private modalService: MdbModalService,
    private crudService: GenericCrudService<any>
  ) {}

  async ngOnInit(): Promise<void> {
    this.loadingFull = true;
    await Promise.all([
      this.getRequestCodeByCompanyId(),
    ]);
    this.loadingFull = false;
  }

  async getRequestCodeByCompanyId(): Promise<void> {
    const body = new FormData();
    const id_company = localStorage.getItem('IdCompany') ?? '';
    body.append('id_company', id_company);
    const response: any = await firstValueFrom(
      this.crudService.crud(body, environment.GetAllRequestCodeByCompanyId)
    );
    if(response && response.status === 1 && response.data) {
      this.requestCodes = response.data.map((item: any) => {
        item.created_at = moment(item.created_at).format('DD-MM-YYYY');
        return item;
      });
      this.requestCodes = this.requestCodes.sort((a, b) => {
        return b.id - a.id;
      });
    }
    this.onPageChange(1);
  }

  seeRequestCode(id: any) {
    this.modalRef = this.modalService.open(ModalSeeCodeRequestComponent, {
      modalClass: 'modal-xl',
      data: {
        id,
        modalTitle: 'Revisar solicitud de código artículo',
        action: 'see',
      },
      ignoreBackdropClick: true,
    });

    this.modalRef.onClose.subscribe(async (modalData: any): Promise<void> => {
      console.log("[CLOSE EVENT] modalData: ", modalData);
      if(modalData) {
        await this.getRequestCodeByCompanyId();
      }
    });
  }

  updatePaginatedData() {
    const start = (this.currentPage) * this.itemsPerPage;
    const end = start + this.itemsPerPage;
    this.requestCodesPaginated = this.requestCodes.slice(start, end);
  }

  onPageChange(event: any) {
    this.currentPage = event.page ?? event - 1;
    this.updatePaginatedData();
  }
}
